import React from 'react';
import { domainExpertise, certifications, sectionImages } from '../mock';
import { Award, ShieldCheck } from 'lucide-react';
import BackToTop from './BackToTop';

export const Domains = () => {
  return (
    <section id="domains" className="relative bg-[#07111f] text-white py-24 lg:py-32 overflow-hidden">
      <div
        className="absolute inset-0 opacity-15 pointer-events-none"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(7,17,31,0.85), rgba(7,17,31,0.95)), url(${sectionImages.domain})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="section-eyebrow">Domain Expertise</div>
          <h2 className="font-display text-4xl md:text-5xl mt-4">
            Where <span className="italic text-[#c9a961]">deep domain</span> meets disciplined delivery.
          </h2>
          <div className="gold-line mt-6" />
          <p className="text-white/70 mt-6 max-w-2xl leading-relaxed">
            From front office to back office, regulatory reporting to portfolio analytics — each
            domain comes with its own contracts, controls and stakeholder rituals.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {domainExpertise.map((d, i) => (
            <div
              key={d.title}
              className="group bg-white/[0.03] border border-white/10 p-7 hover:bg-white/[0.05] hover:border-[#c9a961]/50 transition-all"
            >
              <div className="font-display text-[#c9a961] text-sm">0{i + 1}</div>
              <h3 className="font-display text-2xl text-white mt-3">{d.title}</h3>
              <div className="h-px bg-white/10 my-4 w-12 group-hover:w-20 group-hover:bg-[#c9a961] transition-all" />
              <p className="text-[15px] text-white/70 leading-relaxed">{d.description}</p>
            </div>
          ))}
        </div>
        <BackToTop targetId="domains" label="Top of Domains" variant="dark" className="mt-16" />
      </div>
    </section>
  );
};

export const Certifications = () => {
  return (
    <section id="certifications" className="bg-paper py-24 lg:py-28">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="section-eyebrow">Credentials</div>
          <h2 className="font-display text-4xl md:text-5xl text-[#0c1a2b] mt-4 leading-tight">
            Certifications & continuous learning.
          </h2>
          <div className="gold-line mt-6" />
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {certifications.map((c) => (
            <div key={c.name} className="card-elevated p-7 flex gap-5 items-start">
              <div className="w-12 h-12 border border-[#c9a961] text-[#c9a961] flex items-center justify-center shrink-0">
                <Award size={22} />
              </div>
              <div>
                <h3 className="font-display text-xl text-[#0c1a2b]">{c.name}</h3>
                <div className="text-sm text-[#5b6b7d] mt-1">{c.issuer}</div>
                <p className="text-[14px] text-[#3a4d62] mt-3 leading-relaxed">{c.note}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center gap-3 text-sm text-[#5b6b7d]">
          <ShieldCheck size={16} className="text-[#c9a961]" />
          <span>Aligned to enterprise quality, accessibility (WCAG) and regulatory standards.</span>
        </div>
        <BackToTop targetId="certifications" label="Top of Certifications" variant="light" className="mt-12" />
      </div>
    </section>
  );
};
